module.exports = __webpack_public_path__ + "static/media/processing(1).92243782.svg";